import React, { useState, useEffect } from 'react';

// /**
//  * A custom dropdown component for selecting a language.
//  * It receives all data and state through props.
//  * @param {object} props
//  * @param {object} props.options - The object of languages with id as key and name as value.
//  * @param {boolean} props.isLoading - Whether the parent is currently loading the languages.
//  * @param {object} props.selectedLanguage - The currently selected language object.
//  * @param {function} props.onLanguageSelect - The function to call when a language is selected.
//  */
const LanguageSelector = ({ options, isLoading, selectedLanguage, onLanguageSelect, heightClass = "vh-20",  embeddedDropdown = false}) => {
  // State for managing the UI behavior of the dropdown itself
  const [filteredLanguages, setFilteredLanguages] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchInput, setSearchInput] = useState('');

  // Effect for client-side searching/filtering based on the options prop
  useEffect(() => {
    if (!options || Object.keys(options).length === 0) {
      setFilteredLanguages([]);
      return;
    }
    
    // Convert object to array of [id, name] pairs
    const languageEntries = Object.entries(options);
    
    if (searchInput === '') {
      setFilteredLanguages(languageEntries);
    } else {
      const lowercasedInput = searchInput.toLowerCase();
      const filtered = languageEntries.filter(([id, name]) =>
        name.toLowerCase().includes(lowercasedInput)
      );
      setFilteredLanguages(filtered);
    }
  }, [searchInput, options]);

  // Handler for when a user clicks on a language in the list
    const handleSelectLanguage = (id, name) => {
  const languageObject = { id: parseInt(id), language_name: name };
    onLanguageSelect(languageObject); // Pass the selected language object to the parent
    setIsDropdownOpen(false); // Close the dropdown
    setSearchInput(''); // Clear search
  };

  return (
    <div className="position-relative w-100">
      {!embeddedDropdown && (
        <button
          type="button"
          className="formField4 ev-radius-large ev-btn-small"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <div className ="d-flex justify-content-between align-items-center">
          <span className="ev-reg-p-blue ev-fs-11">
              {selectedLanguage ? (
                <>
                  Preset Language.&nbsp; <b>{selectedLanguage.language_name}</b>
                </>
                
              ) : (
                <>
                  Select Preset Language 
                </>
              )}
          </span>
          <i className={`ev-reg-p-blue bi ${isDropdownOpen ? 'bi-chevron-up' : 'bi-chevron-down'} ms-2`}></i>
          </div>
        </button>
      )}

      {(embeddedDropdown || isDropdownOpen) && (
        <div className="ev-message-card2 d-block ev-card-3 position-absolute z-1000 mt-1 w-100 p-0">
          
          <div className="p-3 pb-0">
            <input
              type="text"
              className="form-control search-input ms-0 ps-3 py-1"
              placeholder="Search languages"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              autoFocus
            />
          </div>
          
          <div className={`scrollable-element p-3 ${heightClass}`}>
            {isLoading && (
              <div className="text-center p-3">
                <div className="spinner-border spinner-border-sm text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}
            
            {!isLoading && filteredLanguages.length === 0 && (
              <p className="ev-small-p-blue text-center mt-3">No languages found</p>
            )}
            
            {!isLoading && filteredLanguages.length > 0 && (
              <div>
                {filteredLanguages.map(([id, name]) => (
                  <div 
                    key={id} 
                    className={`mb-1 ev-btn-small ev-radius-xsmall cursor-pointer ${selectedLanguage?.id === parseInt(id) ? 'list-element-selected' : ''}`}
                    onClick={() => handleSelectLanguage(id, name)}
                  >
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <span className={`${selectedLanguage?.id === parseInt(id) ? 'ev-small-p-light' : 'ev-small-p-blue'} mb-0 ev-bold-reg`}>
                            <i className="bi bi-translate"></i>&nbsp; {name}
                        </span>
                      </div>
                      {selectedLanguage?.id === id && (
                        <i className="bi bi-check-circle-fill text-success"></i>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {!embeddedDropdown && (
  <div className="p-2 text-end">
    <button
      type="button"
      className="ev-btn-light-fill ev-fs-11 ev-btn-xsmall"
      onClick={() => setIsDropdownOpen(false)}
    >
      Close
    </button>
  </div>
)}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;